import React from 'react';
import { useTranslation } from 'react-i18next';
import AboutCTA from './AboutCTA';
import AboutDifferent from './AboutDifferent';
import AboutHero from './AboutHero';
import AboutLocations from './AboutLocations';
import AboutPartnerSection from './AboutPartnerSection';
import AboutVisionMission from './AboutVisionMission';
import SEO from '../SEO/SEO';
import { BreadcrumbSchema } from '../SEO/StructuredData';

const AboutPageLayout: React.FC = () => {
  const { t } = useTranslation();

  return (
    <main className="pt-[72px]">
      <SEO
        title={t('aboutPageSection.seo.title')}
        description={t('aboutPageSection.seo.description')}
        keywords={t('aboutPageSection.seo.keywords')}
      />
      <BreadcrumbSchema items={[{ name: t('aboutPageSection.breadcrumb.home'), url: '/' }, { name: t('aboutPageSection.breadcrumb.about'), url: '/about' }]} />
      <AboutHero />
      <AboutPartnerSection />
      <AboutVisionMission />
      <AboutDifferent />
      <AboutLocations />
      <AboutCTA />
    </main>
  );
};

export default AboutPageLayout;
